import Vue from 'vue'
import Router from 'vue-router'
import AppHeader from '@/layout/AppHeader' //导航栏
import Index from '@/views/index/Index' //首页
import Kindergarten from '@/views/Kindergarten/Index' //幼儿园
import PrimarySchool from '@/views/PrimarySchool/Index' //小学
import JuniorSchool from '@/views/JuniorSchool/Index' //初中
import HighSchool from '@/views/HighSchool/Index' //高中
import InnovationHighSchool from '@/views/InnovationHighSchool/Index' //创新高中
import SchoolNews from '@/views/SchoolNews/Index' //校园新闻
import SchoolService from '@/views/SchoolService/Index' //校园服务
import Recruitment from '@/views/Recruitment/Index' //招生招聘
import PartyBuilding from '@/views/PartyBuilding/Index' //党建工会
// import AppHeaderOne from '@/layout/AppHeaderOne'
import AppFooter from '@/layout/AppFooter'
import NewsDetails from '@/views/index/NewsDetails' //资讯详情
import Overview from '@/views/OverviewAndWelcome/OverviewDetail' //幼儿园小学概览
import OverviewTwo from '@/views/OverviewAndWelcome/OverviewDetailTwo' //学校概况
import Welcome from '@/views/OverviewAndWelcome/WelcomeDetail' //欢迎词
import FineService from '@/views/index/FineService' //生活篇（精细服务）
import GalleryDetail from '@/views/index/GalleryDetail' //图库详情
import ManagementTeam from '@/views/ManagementTeam/Index' //管理团队
import OverviewDetailHigh from '@/views/OverviewAndWelcome/OverviewDetailHigh' //初高创新高中概览
import TeacherTeam from '@/views/ManagementTeam/TeacherTeam' //教师团队
import NewsList from '@/views/index/NewsList' //新闻列表
import VideoLists from '@/views/index/VideoLists' //校园视频列表
import GalleryLists from '@/views/SchoolNews/GalleryLists' //校园图库列表
import VideoDetail from '@/views/index/VideoDetail' //视频详情
import ServiceList from '@/views/SchoolService/ServiceList' //校园服务膳食公示，卫生保健，交通服务，周末托管板块列表页
import RecruitmentList from '@/views/Recruitment/RecruitmentList' //招生招聘列表
import VibrantCampusList from '@/views/index/VibrantCampusList' //活力校园列表
import FamousSchool from '@/views/index/FamousSchool' //名校列表
import CoCultivation from '@/views/index/CoCultivation' //共育篇
import SchoolStrategy from '@/views/index/SchoolStrategy' //办学方略
import TeacherDetail from '@/views/index/TeacherDetail' //教师/团队详情
//TeacherDetail
Vue.use(Router)
var a=sessionStorage['lang']
export default new Router({
  routes: [{
      path: '/',
      name: 'Index',
      components: {
        default: Index,
        // header: AppHeader,
        // left: AppLeft,
        // header: AppHeader,
      },
      meta:{
        title:'首页'
      }
    },
    {
      path: '/Kindergarten',
      name: 'Kindergarten',
      components: {
        default:Kindergarten,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'幼儿园'
      }
    },
    {
      path: '/PrimarySchool',
      name: 'PrimarySchool',
      components: {
        default: PrimarySchool,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'小学'
      }
    },
    {
      path: '/JuniorSchool',
      name: 'JuniorSchool',
      components: {
        default: JuniorSchool,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'初中'
      }
    },
    {
      path: '/HighSchool',
      name: 'HighSchool',
      components: {
        default: HighSchool,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'高中'
      }
    },
    {
      path: '/InnovationHighSchool',
      name: 'InnovationHighSchool',
      components: {
        default: InnovationHighSchool,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'创新高中'
      }
    },
    {
      path: '/SchoolNews',
      name: 'SchoolNews',
      components: {
        default: SchoolNews,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'校园新闻'
      }
    },
    {
      path: '/SchoolService',
      name: 'SchoolService',
      components: {
        default: SchoolService,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'校园服务'
      }
    },
    {
      path: '/Recruitment',
      name: 'Recruitment',
      components: {
        default: Recruitment,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'招生招聘'
      }
    },
    {
      path: '/PartyBuilding',
      name: 'PartyBuilding',
      components: {
        default: PartyBuilding,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'党建工会'
      }
    },
    {
      path: '/NewsDetails',
      name: 'NewsDetails',
      components: {
        default: NewsDetails,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'详情'
      }
    },
    {
      path: '/Overview',
      name: 'Overview',
      components: {
        default: Overview,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'概览'
      }
    },
    {
      path: '/Welcome',
      name: 'Welcome',
      components: {
        default: Welcome,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'欢迎词'
      }
    },
    {
      path: '/FineService',
      name: 'FineService',
      components: {
        default: FineService,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'精细服务'
      }
    },
    {
      path: '/OverviewTwo',
      name: 'OverviewTwo',
      components: {
        default: OverviewTwo,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'学校概况'
      }
    },
    {
      path: '/GalleryDetail',
      name: 'GalleryDetail',
      components: {
        default: GalleryDetail,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'详情'
      }
    },
    {
      path: '/ManagementTeam',
      name: 'ManagementTeam',
      components: {
        default: ManagementTeam,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'管理团队'
      }
    },
    {
      path: '/OverviewDetailHigh',
      name: 'OverviewDetailHigh',
      components: {
        default: OverviewDetailHigh,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'概览'
      }
    },
    {
      path: '/TeacherTeam',
      name: 'TeacherTeam',
      components: {
        default: TeacherTeam,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'教师团队'
      }
    },
    {
      path: '/NewsList',
      name: 'NewsList',
      components: {
        default: NewsList,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'列表'
      }
    },
    {
      path: '/VideoLists',
      name: 'VideoLists',
      components: {
        default: VideoLists,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'视频列表'
      }
    },
    {
      path: '/GalleryLists',
      name: 'GalleryLists',
      components: {
        default: GalleryLists,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'图库列表'
      }
    },
    {
      path: '/VideoDetail',
      name: 'VideoDetail',
      components: {
        default: VideoDetail,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'视频详情'
      }
    },
    {
      path: '/ServiceList',
      name: 'ServiceList',
      components: {
        default: ServiceList,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'列表'
      }
    },
    {
      path: '/RecruitmentList',
      name: 'RecruitmentList',
      components: {
        default: RecruitmentList,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'列表'
      }
    },
    {
      path: '/VibrantCampusList',
      name: 'VibrantCampusList',
      components: {
        default: VibrantCampusList,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'列表'
      }
    },
    {
      path: '/FamousSchool',
      name: 'FamousSchool',
      components: {
        default: FamousSchool,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'名校列表'
      }
    },
    {
      path: '/CoCultivation',
      name: 'CoCultivation',
      components: {
        default: CoCultivation,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'共育篇'
      }
    },
    {
      path: '/SchoolStrategy',
      name: 'SchoolStrategy',
      components: {
        default: SchoolStrategy,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'办学方略'
      }
    },
    {
      path: '/TeacherDetail',
      name: 'TeacherDetail',
      components: {
        default: TeacherDetail,
        header: AppHeader,
        footer: AppFooter,
      },
      meta:{
        title:'详情'
      }
    },
  ]
})
// NewsDetails
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}



// WEBPACK FOOTER //
// ./src/router/index.js